import { endOfDay } from 'date-fns'

export const endOfDayTimestamp = () => {
  return endOfDay(new Date()).getTime()
}
